import { httpClient } from "../../utils/HttpClient";
import {
  server
} from "../../constants";

import {
    HTTP_GROUP_NAME_FETCHING,
    HTTP_GROUP_NAME_SUCCESS,
    HTTP_GROUP_NAME_FAILED
  } from "../../constants/other";

const setStateGroupNameToSuccess = payload => ({
  type: HTTP_GROUP_NAME_SUCCESS,
  payload: payload
});

const setStateGroupNameToFetching = () => ({
  type: HTTP_GROUP_NAME_FETCHING
});

const setStateGroupNameToFailed = () => ({
  type: HTTP_GROUP_NAME_FAILED
});

/* Get Group Name */
export const getGroupName = (page) => {
  return async (dispatch) => {
    dispatch(setStateGroupNameToFetching());
    await doGetGroupName(dispatch,page);
  };
};


const doGetGroupName = async (dispatch,page) => {
  try {
    const result = await httpClient.get(server.GROUP_NAME_URL, { 
      params: {
        page: page
      }
    })
    dispatch(setStateGroupNameToSuccess(result.data));
  } catch(err)  {
    console.log(err);
    dispatch(setStateGroupNameToFailed());
  }
};

export const getGroupNameById = (id) => {
  return async (dispatch) => {
    dispatch(setStateGroupNameToFetching());

    try {
      const result = await httpClient.get(`${server.GROUP_NAME_URL}/id/${id}`)

      let groupNameResult = result.data

      dispatch(setStateGroupNameToSuccess(groupNameResult));
    } catch(err)  {
      console.log(err);
      dispatch(setStateGroupNameToFailed());
    }
  };
};

export const deleteGroupName = (id) => {
  return async (dispatch) => {
    dispatch(setStateGroupNameToFetching());
    const result = await httpClient.delete(
      server.GROUP_NAME_URL + "/" + `${id}`
    );
    if (result){
      // let url = `${server.GROUP_ITEM_URL}/item/${id}`; //ลบใน item
      // const result = await httpClient.delete(url);
      // if (result) {
      //   alert("Delete Complete");
      //   await doGetGroupName(dispatch);
      // }
      alert("Delete Complete");
      await doGetGroupName(dispatch);
    }
  };
};


